<template>
    <div>
        <span class="text-success">
            <i
                class="fa fa-plus-circle fa-lg icon-button"
                title="Selecionar item"
                @click.stop="abrirModal()"
            ></i>
        </span>
        <b-modal v-model="mostrarModal" @show="preencherModal()">
            <div slot="modal-title">
                Informe valor/quantidade do item do contrato
            </div>
            <b-row>
                <b-col sm="12">
                    <detalhe
                        titulo="Código"
                        :size="size1"
                        v-if="itemContrato"
                        >{{ itemContrato.itemContratoId }}</detalhe
                    >
                    <detalhe
                        titulo="Item do Contrato"
                        :size="size1"
                        v-if="itemContrato"
                        >{{ itemContrato.descricao }}</detalhe
                    >
                    <detalhe
                        titulo="Valor Unitário"
                        :size="size1"
                        v-if="itemContrato"
                        >{{ itemContrato.valorUnitario | currency }}</detalhe
                    >
                    <detalhe
                        titulo="Seq RM"
                        :size="size1"
                        v-if="itemContrato"
                        >{{ itemContrato.seqRM }}</detalhe
                    >
                    <detalhe
                        titulo="Saldo Valor"
                        :size="size1"
                        v-if="itemContrato"
                        >{{ itemContrato.saldoValor | currency }}</detalhe
                    >
                    <detalhe
                        titulo="Saldo Qtd"
                        :size="size1"
                        v-if="itemContrato"
                        ><span v-if="itemContrato.controlaSaldoQtd">{{
                            itemContrato.saldoQtd
                        }}</span>
                        <span v-if="!itemContrato.controlaSaldoQtd"
                            >N/A</span
                        ></detalhe
                    >
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12">
                    <b-row v-if="!apenasQtd">
                        <b-col sm="12">
                            <b-form-group
                                :state="$v.valorUnitario.$error ? false : null"
                                invalid-feedback="O valor é obrigatório"
                            >
                                <label>Valor</label>
                                <money
                                    ref="valorUnitario"
                                    v-model="valorUnitario"
                                    v-bind="money"
                                    class="form-control text-right"
                                    @input.native="$v.valorUnitario.$touch()"
                                ></money>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col sm="12">
                            <b-form-group
                                :state="$v.quantidade.$error ? false : null"
                                invalid-feedback="A quantidade é obrigatória"
                            >
                                <label>Quantidade</label>
                                <money
                                    ref="quantidade"
                                    v-model="quantidade"
                                    v-bind="decimal"
                                    class="form-control text-right"
                                    @input.native="$v.quantidade.$touch()"
                                ></money>
                            </b-form-group>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
            <div slot="modal-footer">
                <b-button
                    variant="secondary"
                    @click.stop="fecharModal()"
                    class="mr-2"
                    >Cancelar</b-button
                >
                <b-button
                    variant="primary"
                    :disabled="$v.$invalid"
                    @click.stop="selecionarItem()"
                >
                    Inserir</b-button
                >
            </div>
        </b-modal>
    </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'

export default {
    props: {
        itemContrato: {
            type: Object
        }
    },

    data() {
        return {
            valorUnitario: 0,
            quantidade: 0,
            mostrarModal: false,
            erros: [],
            size1: '130',
            money: {
                decimal: ',',
                thousands: '.',
                prefix: 'R$ ',
                suffix: '',
                precision: 2,
                masked: false
            },
            decimal: {
                decimal: ',',
                thousands: '.',
                prefix: '',
                suffix: '',
                precision: 2,
                masked: false
            }
        }
    },

    validations: {
        quantidade: {
            required,
            qtdOk() {
                return this.quantidade > 0
            }
        },
        valorUnitario: {
            valorOk() {
                if (this.itemContrato.valorUnitario > 0) {
                    return true
                }
                return this.valorUnitario > 0
            }
        }
    },

    methods: {
        fecharModal() {
            this.valorUnitario = 0
            this.quantidade = 0
            this.$nextTick(() => {
                this.$v.$reset()
            })
            this.mostrarModal = false
        },

        abrirModal() {
            this.mostrarModal = true
        },

        preencherModal() {},

        selecionarItem() {
            let itemDto = {
                itemContratoId: this.itemContrato.itemContratoId,
                descricao: this.itemContrato.descricao,
                valorUnitario:
                    this.itemContrato.valorUnitario > 0
                        ? this.itemContrato.valorUnitario
                        : this.valorUnitario,
                quantidade: this.quantidade
            }
            itemDto.valorTotal = itemDto.valorUnitario * itemDto.quantidade
            this.$emit('selecionarItem', itemDto)
            this.fecharModal()
        }
    },

    computed: {
        apenasQtd() {
            return this.itemContrato.valorUnitario > 0
        }
    }
}
</script>
